import { CASE_REPO } from '@/api/apiModules'

export default {
  viewType: 'table',
  module: CASE_REPO,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {},
  extraParams: {},
  // relationSearch: true,
  allowStatus: {
    TestCaseSharedEdit: { owner: [true] },
    TestCaseSharedDelete: { owner: [true] },
    TestCaseSharedCopy: { relevant: ['SPEC'] }
  },
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '创建人/用例名称',
    searchFieldNameArr: ['testCaseName', 'realName'],
    tips: {
      label: '注：本模块可以查询标准用例与共享用例（个人创建用例），创建共享用例，修改自己创建的共享用例',
      type: 'info'
    },
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'TestCaseSharedCreate'
      },
      {
        slot: 'refresh-rigtht',
        label: 'upload',
        props: {
          type: 'success',
          icon: 'el-icon-upload'
        },
        action: 'TestCaseSharedImport'
      }
    ]
  },

  view: {
    columns: [
      {
        props: {
          label: '用例编码',
          prop: 'testCaseCode',
          width: 135,
          sortField: 'testCaseCode'
        },
        action: 'TestCaseSharedDetail',
        dataType: 'link'
      },
      {
        props: {
          label: '用例名称',
          prop: 'testCaseName'
        }
      },
      {
        props: {
          label: '版本支持',
          prop: 'productVersion',
          width: 240
        }
      },
      {
        props: {
          label: '用例步骤',
          prop: 'testCaseStep'
        }
      },
      {
        props: {
          label: '用例来源',
          prop: 'testCaseCategory',
          sortField: 'testCaseCategory',
          width: 110
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'testCaseCategory'
      },
      {
        props: {
          label: 'testcaseMng.testCaseType',
          prop: 'testCaseType',
          sortField: 'testCaseType',
          width: 110
        },
        filter: true,
        dataType: 'enum',
        dictionaryPath: 'testCaseType'
      },
      // {
      //   props: {
      //     label: '适用范围',
      //     prop: 'relevant',
      //     sortField: 'relevant',
      //     width: 120
      //   },
      //   filter: true,
      //   dataType: 'enum',
      //   dictionaryPath: 'relevant'
      // },
      {
        props: {
          label: '创建人',
          prop: 'realName',
          width: 100
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        //操作
        props: {
          showBtnNum: '3'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'TestCaseSharedEdit',
        name: 'TestCaseSharedEdit',
        tip: '由本人创建的用例才能编辑'
      },
      {
        icon: 'sk-icon-copy',
        label: '复制',
        command: 'TestCaseSharedCopy',
        name: 'TestCaseSharedCopy',
        tip: '通用用例不支持复制'
      },
      {
        icon: 'el-icon-delete',
        label: '删除',
        command: 'TestCaseSharedDelete',
        name: 'TestCaseSharedDelete',
        confirm: {
          grade: 0,
          msg: 'tips.confirm.testCaseShared.deleteMsg'
        },
        tip: '由本人创建的用例才能删除'
      }
    ]
  }
}
